import React, { useState, useEffect } from 'react';
import { useStateValue } from './StateProvider';
import StatementAccount from "./StatementAccount";

import { getCashAccounts } from './Utils/cashaccounts.js';
import { getClientAccounts } from './Utils/clients.js';
import { getIncomeAccounts } from './Utils/incomeaccounts.js';
import { getExpenseAccounts } from './Utils/expenseaccounts.js';
import { getAssetAccounts } from './Utils/assetaccounts.js';
import { getSupplierAccounts } from './Utils/suppliers.js';
import { getLiabilityAccounts } from './Utils/liabilityaccounts.js';
import { getEquityAccounts } from './Utils/equityaccounts.js';

import Title from './Title';

import './Summary.css';

function Summary({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const clientsdata = getClientAccounts(project);
    const cashdata = getCashAccounts(project);
    const assetdata = getAssetAccounts(project);
    const liabilitydata = getLiabilityAccounts(project);
    const supplierdata = getSupplierAccounts(project);
    const equitydata = getEquityAccounts(project);
    const incomedata = getIncomeAccounts(project);
    const expensedata = getExpenseAccounts(project);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleAccountStatement = (type, account) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <StatementAccount state={state} setState={setState} type={type} account={account} />, modaltype: 'large', modaltitle: 'Statement of Account' }));
    };

    function CashAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.filter(client => client.balance != 0).map((client, index) => {
                                return (
                                    <tr key={'client' + index}>
                                        <td><div>{client.name}</div></td>
                                        <td>
                                            <div
                                                className='summary_balance'
                                                onClick={() =>
                                                    handleAccountStatement(
                                                        "cashaccounts",
                                                        {
                                                            id: client.id,
                                                            name: client.name,
                                                            from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                            to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                            subaccountid: '',
                                                            currencyid: project.basecurrency,
                                                        }
                                                    )
                                                }>
                                                {client.currencysymbol + ' ' + client.balance.toLocaleString('en-US')}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function ClientAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data
                                .filter(data => data.balance != 0)
                                .map((client, index) => {
                                    return (
                                        <tr key={'client' + index}>
                                            <td><div>{client.name}</div></td>
                                            <td>
                                                <div
                                                    className='summary_balance'
                                                    onClick={() =>
                                                        handleAccountStatement(
                                                            "clients",
                                                            {
                                                                id: client.id,
                                                                name: client.name,
                                                                from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                                to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                                subaccountid: '',
                                                                currencyid: client.currencyid,
                                                            }
                                                        )
                                                    }
                                                >
                                                    {client.currencysymbol + ' ' + client.balance.toLocaleString('en-US')}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function AssetAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((asset, index) => {
                                return (
                                    <tr key={'asset' + index}>
                                        <td><div>{asset.name}</div></td>
                                        <td>
                                            <div
                                                className='summary_balance'
                                                onClick={() =>
                                                    handleAccountStatement(
                                                        "assets",
                                                        {
                                                            id: asset.id,
                                                            name: asset.name,
                                                            from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                            to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                            subaccountid: '',
                                                            currencyid: asset.currencyid,
                                                        }
                                                    )
                                                }>
                                                {asset.currencysymbol + ' ' + asset.balance.toLocaleString('en-US')}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function IncomeAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((account, index) => {
                                if (account.tabletype === 'group') {
                                    return (
                                        <tr key={'account' + index}>
                                            <td><div className='summary_incomegroup'>{account.name}</div></td>
                                            <td></td>
                                        </tr>
                                    );
                                }
                                if (account.tabletype === 'account') {
                                    return (
                                        <tr key={'account' + index}>
                                            <td><div className='summary_incomeaccount'>{account.name}</div></td>
                                            <td>
                                                <div
                                                    className='summary_balance'
                                                    onClick={() =>
                                                        handleAccountStatement(
                                                            account.type,
                                                            {
                                                                id: account.id,
                                                                name: account.name,
                                                                from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                                to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                                subaccountid: '',
                                                                currencyid: account.currencyid
                                                            }
                                                        )
                                                    }>
                                                    {account.currencysymbol + ' ' + account.balance.toLocaleString('en-US')}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function ExpenseAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data
                                .filter(account => account.balance != 0)
                                .map((account, index) => {
                                    if (account.tabletype === 'group') {
                                        return (
                                            <tr key={'account' + index}>
                                                <td><div className='summary_group'>{account.name}</div></td>
                                                <td></td>
                                            </tr>
                                        );
                                    }
                                    if (account.tabletype === 'account') {
                                        return (
                                            <tr key={'account' + index}>
                                                <td><div className='summary_account'>{account.name}</div></td>
                                                <td>
                                                    <div
                                                        className='summary_balance'
                                                        onClick={() =>
                                                            handleAccountStatement(
                                                                account.type,
                                                                {
                                                                    id: account.id,
                                                                    name: account.name,
                                                                    from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                                    to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                                    subaccountid: '',
                                                                    currencyid: account.currencyid
                                                                }
                                                            )
                                                        }>
                                                        {account.currencysymbol + ' ' + account.balance.toLocaleString('en-US')}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function EquityAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((equity, index) => {
                                return (
                                    <tr key={'equity' + index}>
                                        <td><div>{equity.name}</div></td>
                                        <td>
                                            <div
                                                className='summary_balance'
                                                onClick={() =>
                                                    handleAccountStatement(
                                                        "equityaccounts",
                                                        {
                                                            id: equity.id,
                                                            name: equity.name,
                                                            from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                            to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                            subaccountid: '',
                                                            currencyid: equity.currencyid,
                                                        }
                                                    )
                                                }>
                                                {equity.currencysymbol + ' ' + equity.balance.toLocaleString('en-US')}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function LiabilityAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((liability, index) => {
                                return (
                                    <tr key={'liability' + index}>
                                        <td><div>{liability.name}</div></td>
                                        <td>
                                            <div
                                                className='summary_balance'
                                                onClick={() =>
                                                    handleAccountStatement(
                                                        "liabilityaccounts",
                                                        {
                                                            id: liability.id,
                                                            name: liability.name,
                                                            from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                            to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                            subaccountid: '',
                                                            currencyid: liability.currencyid,
                                                        }
                                                    )
                                                }>
                                                {liability.currencysymbol + ' ' + liability.balance.toLocaleString('en-US')}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    function SupplierAccounts(data, title) {
        return (
            <div className='summary_tablecontainer'>
                <table className='summary_table'>
                    <thead>
                        <tr>
                            <th className="summary_tableheader" colSpan={2}>
                                {title}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((liability, index) => {
                                return (
                                    <tr key={'liability' + index}>
                                        <td><div>{liability.name}</div></td>
                                        <td>
                                            <div
                                                className='summary_balance'
                                                onClick={() =>
                                                    handleAccountStatement(
                                                        "suppliers",
                                                        {
                                                            id: liability.id,
                                                            name: liability.name,
                                                            from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                            to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                            subaccountid: '',
                                                            currencyid: liability.currencyid,
                                                        }
                                                    )
                                                }>
                                                {liability.currencysymbol + ' ' + liability.balance.toLocaleString('en-US')}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className='summary'>
            <Title text='Summary' />

            <div className='summary_row'>
                <div className='summary_column'>
                    <div className='summary_sectiontitle'>Assets</div>
                    {CashAccounts(cashdata, 'Cash & Bank Accounts')}
                    {ClientAccounts(clientsdata, 'Clients')}
                    {AssetAccounts(assetdata, 'Assets')}
                </div>
                <div className='summary_column'>
                    <div className='summary_sectiontitle'>Profit & Loss</div>
                    {IncomeAccounts(incomedata, 'Income')}
                </div>
            </div>

            <div className='summary_row'>
                <div className='summary_column'>
                    <div className='summary_sectiontitle'>Liabilities</div>
                    {LiabilityAccounts(liabilitydata, 'Liabilities')}
                    {SupplierAccounts(supplierdata, 'Suppliers')}
                </div>
                <div className='summary_column'>
                    {ExpenseAccounts(expensedata, 'Expenses')}
                </div>
            </div>

            <div className='summary_row'>
                <div className='summary_column'>
                    <div className='summary_sectiontitle'>Equity</div>
                    {EquityAccounts(equitydata, 'Equity')}
                </div>
                <div className='summary_column'>
                </div>
            </div>
        </div>
    );
}

export default Summary;